<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-data-provider-entity-page">
  <div class="org-admin-data-provider-entity-page--layout">
    <app-org-admin-sidebar class="org-admin-data-provider-entity-page--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-data-provider-entity-page--content">
      <app-page-header></app-page-header>
      <div class="data-provider-entity-container">
        <!-- Granted Request Info Message -->
        <div *ngIf="organisationStatus === 'granted'" class="granted-request-info">
          <div class="granted-request-info--icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="granted-request-info--text">
            <strong>Your organisation has been approved.</strong> You can now access all organisation features and capabilities.
          </div>
        </div>

        <app-data-provider-entity-form
          [formData]="formData"
        ></app-data-provider-entity-form>
      </div>
    </div>
  </div>
</div>
